module.exports = __webpack_public_path__ + "img/logo.8ae4fa61.png";